import { gql } from "@apollo/client";
import { CONTACT_FIELDS } from "./query";

export const CREATE_CONTACT = gql`
  mutation CreateAddressbookContact($input: CreateContactInput!) {
    createContact(input: $input) {
      contact {
        ...ContactFields
      }
    }
  }
  ${CONTACT_FIELDS}
`;

export const UPDATE_CONTACT = gql`
  mutation UpdateAddressbookContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      contact {
        ...ContactFields
      }
    }
  }
  ${CONTACT_FIELDS}
`;

export const DELETE_CONTACT = gql`
  mutation DeleteAddressbookContact($id: ID!, $authorId: String!) {
    deleteContact(id: $id, authorId: $authorId) {
      id
    }
  }
`;

export const CHAT_ABOUT_CONTACT = gql`
  mutation ChatAboutContact($input: ChatAboutContactInput!) {
    chatAboutContact(input: $input) {
      response
    }
  }
`;

export const SEND_EMAIL_TO_CATEGORY = gql`
  mutation SendEmailToCategory($input: SendEmailToCategoryInput!) {
    sendEmailToCategory(input: $input) {
      totalMatched
      totalAttempted
      totalSent
      totalFailed
      totalSkipped
      results {
        contactId
        email
        status
        error
        messageId
      }
    }
  }
`;
